export const getTextColor = (color: string) => {
  return `
          a, abbr, acronym, address, applet, article, aside, audio, b, big, blockquote, 
          body, button, canvas, caption, center, cite, code, dd, del, details, dfn, div, 
          dl, dt, em, embed, fieldset, figcaption, figure, footer, form, h1, h2, h3, h4, 
          h5, h6, header, hgroup, html, i, iframe, img, ins, kbd, label, legend, li, mark, 
          menu, nav, object, ol, output, p, pre, q, ruby, s, samp, section, small, span, 
          strike, strong, sub, summary, sup, table, tbody, td, tfoot, th, thead, time, tr, 
          tt, u, ul, var, video {
            color: ${color};
          }
        `;
};
